import React, {useState} from 'react';
import { withRouter } from 'react-router-dom';
import cn from "classnames";
import {useDispatch} from "react-redux";
import swal from 'sweetalert';
import {SupplierModal} from "./SupplierModal";
import Content from "../../../components/layout/Content";
import {deleteSuppliers} from "../../../action";

const Item = ({ item }) => {
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentSupplier, setCurrentSupplier] = useState(null);

    const handleDelete = () => {
        swal({
            title: "Вы уверены?",
            text: `Вы хотите удалить поставщика "${item.name}"?`,
            icon: "warning",
            buttons: ["Отмена", "Удалить"],
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(deleteSuppliers(item.id));
                swal("Поставщик успешно удалён!", {
                    icon: "success",
                });
            }
        });
    };

    const handleEdit = () => {
        setIsModalOpen(true);
        setIsEditMode(true);
        setCurrentSupplier(item);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <Content>
            <tr key={`${item.id}_item`} className="kt-datatable__row">
                <td width="45px" className="kt-datatable__cell">
                    <span>{item.id}</span>
                </td>
                <td width="280px" className="kt-datatable__cell">
                    <span>{item.name ? item.name : "Не указан"}</span>
                </td>
                <td align="right" width="180px" className="kt-datatable__cell">
                    <button
                        data-tip="Редактирование"
                        className="btn btn-sm btn-clean btn-icon btn-icon-md"
                        onClick={handleEdit}
                    >
                        <i className="la la-edit"></i>
                    </button>
                    <button
                        data-tip="Удалить"
                        className={cn("btn btn-sm btn-clean btn-icon btn-icon-md")}
                        onClick={handleDelete}
                    >
                        <i className="la la-trash"></i>
                    </button>
                </td>
            </tr>
            {isModalOpen && (
                <SupplierModal
                    onClose={closeModal}
                    isEditMode={isEditMode}
                    supplier={currentSupplier}
                />
            )}
        </Content>

    );
};

export const ItemRow = withRouter(Item);
